import React from 'react';
import { MapPin, MessageCircle, Phone, StickyNote, PartyPopper, Bell } from 'lucide-react';
import { Lead, STAGES } from '../types';
import { eur, todayStr, daysUntil } from '../lib/utils';
interface FollowViewProps {
  leads: Lead[];
  onLeadClick: (id: string) => void;
}
export function FollowView({
  leads,
  onLeadClick
}: FollowViewProps) {
  const dueLeads = leads.filter(l => l.next && l.next <= todayStr() && l.stage !== 'win').sort((a, b) => (a.next || '').localeCompare(b.next || ''));
  const Banner = <div className="bg-gradient-to-r from-cream-2 to-cream-2/40 border-l-[3px] border-wood rounded-xl p-4 text-[13.5px] mb-5 text-charcoal-soft flex items-start gap-3" data-id="element-16">
      <Bell className="w-5 h-5 text-wood flex-shrink-0 mt-0.5" strokeWidth={2.4} data-id="element-17" />
      <div className="leading-relaxed" data-id="element-18">
        <b className="text-charcoal" data-id="element-19">
          El 50% de las obras se cierran en el seguimiento.
        </b>{' '}
        Aquí salen los leads a contactar HOY.
      </div>
    </div>;
  if (dueLeads.length === 0) {
    return <div data-id="element-20">
        {Banner}
        <div className="bg-white border border-line rounded-2xl py-12 px-6 text-center shadow-card" data-id="element-21">
          <div className="w-14 h-14 rounded-full bg-green/10 text-green mx-auto mb-3 flex items-center justify-center" data-id="element-22">
            <PartyPopper className="w-7 h-7" strokeWidth={2.2} data-id="element-23" />
          </div>
          <div className="font-poppins font-extrabold text-[15px] text-charcoal mb-1" data-id="element-24">
            Nada pendiente para hoy
          </div>
          <div className="text-[12.5px] text-[#8a8175] font-semibold" data-id="element-25">
            Todo controlado. Vuelve mañana.
          </div>
        </div>
      </div>;
  }
  return <div data-id="element-26">
      {Banner}
      <div className="space-y-3" data-id="element-27">
        {dueLeads.map(lead => {
        const days = daysUntil(lead.next);
        const tag = days < 0 ? <span className="badge-hot" data-id="element-28">Vencido {-days}d</span> : <span className="badge-warn" data-id="element-29">Hoy</span>;
        const phone = String(lead.phone || '').replace(/\D/g, '');
        const phoneWa = phone.startsWith('34') ? phone : '34' + phone;
        const stageName = STAGES.find(s => s.id === lead.stage)?.name || '';
        return <div key={lead.id} className={`bg-white border rounded-2xl p-4 shadow-card hover:shadow-lg transition-all ${days < 0 ? 'border-red/30' : 'border-line'}`} data-id="element-30">
              <div onClick={() => onLeadClick(lead.id)} className="cursor-pointer" data-id="element-31">
                <div className="flex items-start justify-between gap-2 mb-1.5" data-id="element-32">
                  <div className="font-poppins font-extrabold text-[15.5px] text-charcoal leading-tight" data-id="element-33">
                    {lead.name}
                  </div>
                  {tag}
                </div>
                <div className="text-[12.5px] text-[#8a8175] font-medium flex flex-wrap items-center gap-x-2 gap-y-0.5 mb-2" data-id="element-34">
                  <span className="inline-flex items-center gap-1" data-id="element-35">
                    <MapPin className="w-3 h-3" strokeWidth={2.5} data-id="element-36" />
                    {lead.zone || '—'}
                  </span>
                  <span data-id="element-37">·</span>
                  <span data-id="element-38">{stageName}</span>
                  {lead.value > 0 && <>
                      <span data-id="element-39">·</span>
                      <span className="text-wood font-extrabold" data-id="element-40">
                        {eur(lead.value)}
                      </span>
                    </>}
                </div>
                {lead.notes && <div className="text-[12px] text-charcoal-soft font-medium mb-3 flex items-start gap-1.5 bg-cream/60 rounded-lg px-2.5 py-2 border border-line/60" data-id="element-41">
                    <StickyNote className="w-3.5 h-3.5 text-wood flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-42" />
                    {lead.notes}
                  </div>}
              </div>
              {phone && <div className="flex gap-2 flex-wrap" data-id="element-43">
                  <a href={`https://wa.me/${phoneWa}`} target="_blank" rel="noopener noreferrer" className="flex-1 text-center bg-wa text-white no-underline font-extrabold text-[13px] py-3 px-3 rounded-xl flex items-center justify-center gap-1.5 hover:bg-wa-dark active:scale-[0.98] transition-all shadow-sm" data-id="element-44">
                    <MessageCircle className="w-4 h-4" strokeWidth={2.5} data-id="element-45" />
                    WhatsApp
                  </a>
                  <a href={`tel:${phone}`} className="flex-1 text-center bg-charcoal text-white no-underline font-extrabold text-[13px] py-3 px-3 rounded-xl flex items-center justify-center gap-1.5 hover:bg-charcoal-soft active:scale-[0.98] transition-all shadow-sm" data-id="element-46">
                    <Phone className="w-4 h-4" strokeWidth={2.5} data-id="element-47" />
                    Llamar
                  </a>
                </div>}
            </div>;
      })}
      </div>
    </div>;
}